import React ,{ useState , useEffect } from 'react';

//import { Helmet } from 'react-helmet';

import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import TopBooks from './TopBooks';

import Parsig01 from '../../images/icon1.jpg'
import Parsig02 from '../../images/icon2.jpg'
import Parsig04 from '../../images/icon4.jpg'
import Parsig03 from '../../images/icon3.jpg'
import Parsig1jpg from '../../images/1.jpg'
import fig9 from '../../images/Footer Logo 1.png'
import fig10 from '../../images/Footer Logo 2.png'
import fig11 from '../../images/Footer Logo 3.png'
import fig12 from '../../images/Footer Logo 4.png'
//import Parsigpazhouheshgahpng from '../../images/22.jpg'
//import jpeg2 from '../../images/23.jpg'
//import Parsigashajpeg from '../../images/asha.jpg'
//import Parsigsandoughpng from '../../images/sandough.png'

// import OwlCarousel from 'react-owl-carousel2';
// import '../../css/owl.theme.default.css';
// import '../../css/owl.style.css';
 
import '../../css/style.css';

//import LoadingGif from '../../images/loading.gif';

// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';

const Home = (props) => {
    
    //const [statments,setStatments] = useState([]);
    const [languageInfo,setLanguageInfo] = useState([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
    const [pageData,setPageData] = useState(undefined);
    //const [topBooks,setTopBooks] = useState(undefined);
    const [wordSummery,setWordSummery] = useState(undefined);

    useEffect(() => {
        async function getLanguageInfo(languageCode){

            //console.log('languageCode:',languageCode)
            const responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+languageCode)
            
            const resLanguageinfoData = await responseResultLanguageinfo.data;

            //console.log(resLanguageinfoData);
            //console.log(resLanguageinfoData.length);
            
            if (resLanguageinfoData && resLanguageinfoData.length>0)
            {
                setLanguageInfo(resLanguageinfoData);
                //setState({lang : responseResultlanguageinfo.data[0].Code});
                document.getElementsByTagName('html')[0].setAttribute("lang", resLanguageinfoData[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("dir", resLanguageinfoData[0].Direction);
            }
            else
            {
                setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
                //setState({lang : responseResultlanguageinfo.data[0].Code});
                document.getElementsByTagName('html')[0].setAttribute("lang","fa");
                document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            }
        }

        async function getLangCodeOfUrl() {

            if (new URLSearchParams(props.location.search).get("lang")!=null)
            {
                //console.log('langFromURL: ',new URLSearchParams(props.location.search).get("lang"));
                //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
                getLanguageInfo(new URLSearchParams(props.location.search).get("lang"));
                //console.log(languageInfo);
            }else{
                setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);

                document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
                document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            }
        }

        getLangCodeOfUrl();
    }, [props]);

    useEffect(()=>{
        async function pageList() {
            if (languageInfo)
            {
                const pageList = await webapi.get('pages/datapages/1/'+languageInfo[0].Code);
                //console.log('101',pageList);
                setPageData(pageList.data);
            }else{
                const pageList = await webapi.get('pages/datapages/1/fa');
                //console.log(pageList);
                setPageData('102',pageList.data);
            }

            // const topBooksRes = await webapi.get('book/topbooks/'+languageInfo[0].Code);
            // //console.log(TopBooksConst.data[0].FormStatusCode==='BS_Loading');
            // setTopBooks(topBooksRes.data);

            const wordSummeryRes = await webapi.get('pages/wordsummery');
            //console.log(WordSummery.data);
            setWordSummery(wordSummeryRes.data);
        }

        pageList()
    },[languageInfo])



    if (pageData && languageInfo) {
        return (
            <div>
                {
                    //<Helmet htmlAttributes={{lang: languageInfo[0].Code}} />
                }

                <Header     languageInfo = {languageInfo}/>

                <div className="container-fluid" id="firstpage_row_1">
                    <div className="container">
                        <div id="columns">
                            <div className="column">
                                <h3>
                                    <a href={process.env.PUBLIC_URL+'/surf/?lang='+languageInfo[0].Code}><img alt="01" src={Parsig01} />{pageData.length!==0 && pageData[0].F10101!== undefined?pageData[0].F10101:10101}</a>
                                </h3>
                            </div>
                            <div className="column">                                    
                                <h3>
                                    <a href={process.env.PUBLIC_URL+'/search/?lang='+languageInfo[0].Code}><img alt="01" src={Parsig04} />{pageData.length!==0 && pageData[0].F10102!== undefined?pageData[0].F10102:10102}</a>                                      
                                </h3>
                            </div>
                            <div className="column">                                    
                                <h3>
                                    <a href={process.env.PUBLIC_URL+'/tags/?lang='+languageInfo[0].Code}><img alt="01" src={Parsig02} />{pageData.length!==0 && pageData[0].F10103!== undefined?pageData[0].F10103:10103}</a>
                                </h3>
                            </div>
                            <div className="column">                                    
                                <h3>
                                    <a href={process.env.PUBLIC_URL+'/relative/?lang='+languageInfo[0].Code}><img alt="01" src={Parsig03} />{pageData.length!==0 && pageData[0].F10104!== undefined?pageData[0].F10104:10104}</a>
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid" id="firstpage_row_2">
                    <div className="container">
                        <div id="firstpage_row_2_img">
                            <img alt="01" src={Parsig1jpg} />
                        </div>
                        <div id="firstpage_row_2_text">
                            <h4>{pageData.length!==0 && pageData[0].F10105!== undefined?pageData[0].F10105:10105}</h4>
                            <hr />
                            <p style={{textAlign:"justify"}} dangerouslySetInnerHTML={{__html:pageData.length!==0 && pageData[0].F10106!== undefined?pageData[0].F10106:10106}}></p>
                            <a href={"/aboutus?lang="+languageInfo[0].Code} className="btn btn-outline-primary">{pageData.length!==0 && pageData[0].F10107!== undefined?pageData[0].F10107:10107/*بیشتر بخوانید*/}</a>
                        </div>
                    </div>
                </div>

                <TopBooks   pageData={pageData}
                            languageInfo = {languageInfo}
                />

                <div className="container-fluid" id="firstpage_row_5">
                    <div className="container">
                    {
                        (wordSummery && wordSummery.length>0)
                        ?
                        <div id="columns">
                            <div className="column">
                                <img alt="01" src={fig9} />
                                <h6>{pageData.length!==0 && pageData[0].F10201!== undefined?pageData[0].F10201:10201/*متون بارگذاری شده*/}</h6>
                                <p>{wordSummery[0].BookCount}</p>
                            </div>
                            <div className="column">
                                <img alt="01" src={fig10} />
                                <h6>{pageData.length!==0 && pageData[0].F10202!== undefined?pageData[0].F10202:10202/*واژه های بارگذاری شده*/}</h6>
                                <p>{wordSummery[0].TextWordCount}</p>
                            </div>
                            <div className="column">
                                <img alt="01" src={fig11} />
                                <h6>{pageData.length!==0 && pageData[0].F10203!== undefined?pageData[0].F10203:10203/*واژه های بدون تکرار*/}</h6>
                                <p>{wordSummery[0].WordCount}</p>
                            </div>
                            <div className="column">
                                <img alt="01" src={fig12} />
                                <h6>{pageData.length!==0 && pageData[0].F10204!== undefined?pageData[0].F10204:10204/*بن واژه های بارگذاری شده*/}</h6>
                                <p>{wordSummery[0].WordRootCount}</p>
                            </div>
                        </div>
                        :
                        null
                    }
                    </div>
                </div>
                
                <div className="container-fluid" id="firstpage_row_3">
                    <div className="container">
                        {/* <div id="firstpage_row_3_text">
                            <h4>حامیان پارسیگ</h4>
                            <hr />
                        </div> */}
                        {/* <div id="columns">
                        <div className="column"></div>
                            <div className="column">
                                <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={jpeg2} /></a>
                                </div>
                            <div className="column">
                                <a href="http://www.ihcs.ac.ir/fa" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigpazhouheshgahpng} /></a>
                            </div>
                            
                            <div className="column">
                                <a href="http://www.ashaerp.com" target="_blank" rel="noopener noreferrer"><img alt="01" src={Parsigashajpeg} /></a>
                            </div>
                            <div className="column"></div>
                        </div> */}
                    </div>
                </div>

                <Footer  lang = {languageInfo[0].Code}/>
            </div>
        );
    } else {
        return (
            <div></div>
        )
    }
}

export default Home;